import { testMsg } from "../test-apis";
import { isTestCompany } from "../utils/auth";
import http from "../utils/http";
import { toast } from "../utils/toast";

// 근무 일정 목록
export const getWorkScheduleList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/schedule/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 일정 등록
export const createWorkSchedule = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .post("/work/schedule", body)
      .then((res) => {
        toast.success('근무일정이 등록 되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 일정 수정
export const modifyWorkSchedule = (scheduleIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .put(`/work/schedule/${scheduleIdx}`, body)
      .then((res) => {
        toast.success('근무일정이 수정 되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 일정 삭제
export const deleteWorkSchedule = (scheduleIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .delete(`/work/schedule/${scheduleIdx}`)
      .then((res) => {
        toast.info('근무일정이 삭제 되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 일정 직원 배정 목록
export const getWorkScheduleAssignList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/schedule/assign/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 일정에 배정 등록
export const createWorkScheduleAssign = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .post("/work/schedule/assign", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 일정 배정의 적용일 수정
export const modifyWorkScheduleAssign = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .put("/work/schedule/assign", body)
      .then((res) => {
        toast.success('근무 적용일이 수정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 일정 배정 정보 삭제
export const deleteWorkScheduleAssign = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .delete("/work/schedule/assign", {
        data: body,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 일정 배정 변경내역 목록
export const getWorkScheduleAssignHistoriesList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/schedule/assign/histories/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
